import { useState, useEffect } from "react"
import { Row, Col, Button, Container } from "react-bootstrap"
import Input from "../../components/Input"
import Label from "../../components/Label"
import Loading from "../../components/Loading"
import { BranchData, useBranch } from "../../api/branch/store"


type BranchRowInterface = {
    branch: BranchData,
    onDelete: (data: BranchData) => void,
}

const BranchRow: React.FC<BranchRowInterface & { editable: boolean }> = ({ branch, onDelete, editable = true }) => {
    return <Row>
        <Col>{branch.name}</Col>
        <Col>{branch.id}</Col>
        {editable && <Col sm="auto"><Button size="sm" variant="outline-danger" onClick={() => onDelete(branch)}>Delete</Button></Col>}
    </Row>
}


const BranchItem = ({ com = "", editable = true }) => {
    const { retrieveBranches, addBranch, branches, removeBranch } = useBranch(state => state)
    const [adding, setAdding] = useState(false)
    const [crole, setCRole] = useState<BranchData>({
        name: "",
        id: "",
    })
    const [retrieving, setRetrieving] = useState(false)
    useEffect(() => {
        setRetrieving(true)
        retrieveBranches(com!)
            .finally(() => setRetrieving(false))
    }, [])
    const onAdded = (branch: BranchData) => {
        setAdding(true)
        addBranch(com, branch)
            .then(code => {
                // TODO: add toast
                if (code === "200") {
                    setCRole({ name: "", id: "" })
                }
            })
            .catch(err => {

            })
            .finally(() => setAdding(false))
    }
    const onBranchDelete = (branch: BranchData) => {
        removeBranch(branch.id, com)
        // TODO: add toast
    }
    if (retrieving)
        return <div style={{ paddingTop: 20, paddingBottom: 20 }}><Loading center={true} /></div>

    return <Container>
        <Row style={{ paddingBottom: 10 }}>
            <Col><Label size="medium" >Name</Label></Col>
            <Col><Label size="medium" >Id</Label></Col>
            <Col sm="auto"><div style={{ width: 30 }} /></Col>
        </Row>
        {branches[com] && branches![com]!.map(item => <BranchRow branch={item} onDelete={onBranchDelete} editable={editable} />)}
        {editable && <Row style={{ padding: 10 }}>
            <Col style={{ padding: 0 }}><Input placeholder="Name"
                disabled={adding}
                value={crole.name}
                onChange={(e: any) => setCRole({ ...crole, name: e.target.value })} /></Col>
            <Col><Input placeholder="Id"
                disabled={adding}
                value={crole.id}
                onChange={(e: any) => setCRole({ ...crole, id: e.target.value })} /></Col>
            <Col sm="auto"><Button size="sm" onClick={() => onAdded(crole)}>Add</Button></Col>
        </Row>}
    </Container>
}

export default BranchItem